import { useParams } from "react-router";
import React, { useEffect, useState } from "react";
import { ProjectData } from "./Projects/ProjectData";
import * as FaIcons from "react-icons/fa";
import { useLocation, Link } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";
import { extractColors } from "extract-colors";
import { GoLinkExternal } from "react-icons/go";

const ProjectDetail = () => {
  const { pathname } = useLocation();
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");
  const [colors, setColors] = useState([]);
  const { project: projectName } = useParams();
  const name = projectName.split("-").join(" ").split(".").join("-");

  const project = ProjectData.find(
    (elt) => elt.title.toLowerCase() === name.toLowerCase()
  );

  const prodIndex = ProjectData.findIndex((p) => {
    return p.title.toLowerCase() === name.toLowerCase();
  });

  // const goToNextProject = (prop) => {
  //   const index = prodIndex + 1 === ProjectData.length - 1 ? 0 : prodIndex + 1;
  //   let project = ProjectData[index];
  //   console.log(project);

  //   window.location.href =
  //     "/projects/" +
  //     project.title.toLowerCase().split("-").join(".").split(" ").join("-");
  // };

  // const goToNextPrevProject = (prop) => {
  //   const index = prodIndex - 1 >= 0 ? prodIndex - 1 : ProjectData.length - 1;
  //   let project = ProjectData[index];
  //   // window.location.href =
  //   //   "/projects/" +
  //   //   project.title.toLowerCase().split("-").join(".").split(" ").join("-");
  //   return project.title
  //     .toLowerCase()
  //     .split("-")
  //     .join(".")
  //     .split(" ")
  //     .join("-");
  // };
  useEffect(() => {
    setPrev(() => {
      const index = prodIndex - 1 >= 0 ? prodIndex - 1 : ProjectData.length - 1;
      let project = ProjectData[index];
      return project.title
        .toLowerCase()
        .split("-")
        .join(".")
        .split(" ")
        .join("-");
    });
    setNext(() => {
      const index = prodIndex + 1 === ProjectData.length ? 0 : prodIndex + 1;
      let project = ProjectData[index];
      return project.title
        .toLowerCase()
        .split("-")
        .join(".")
        .split(" ")
        .join("-");
    });
    extractColors(project.img)
      .then((colors) => {
        setColors(colors.map((color) => color.hex));
        const gotonext = document.querySelector(".gotonext");
        const gotoprev = document.querySelector(".gotoprev");
        const skills = document.querySelectorAll(".skills li");

        gotonext.style.backgroundColor = colors[0].hex;
        gotoprev.style.backgroundColor = colors[0].hex;

        //Set the skills background color on hover
        skills.forEach((skill) => {
          skill.addEventListener("mouseover", (e) => {
            e.target.style.backgroundColor = colors[0].hex;
          });
          skill.addEventListener("mouseout", (e) => {
            e.target.style.backgroundColor = "rgb(226 232 240)";
          });
        });
      })
      .catch(console.error);
  }, [pathname, prodIndex, project.img]);

  //Navigate to top of page
  useEffect(() => {
    scroll.scrollToTop({ duration: 1500 });
    //Change the img-container background
    const imgContainer = document.querySelector(".img-contaimer");
    imgContainer.style.backgroundImage = `url(${project.img})`;
  }, [prodIndex, project.img]);

  // useEffect(() => {},[prodIndex]);

  // const src = "my-image.jpg";

  return (
    <div className="h-full overflow-hidden lg:grid grid-cols-2 ">
      <div className="col-span-1 flex  h-full justify-center img-contaimer lg:bg-center">
        <img src={project.img} alt={project.alt} className="lg:hidden w-full" />
      </div>
      <div className="col-span-1 p-2 relative">
        <h1 className="capitalize lg:text-xl font-semibold py-2">{name}</h1>
        <h1 className="capitalize lg:text-xl font-semibold py-2">Tech Stack</h1>
        <div>
          <ul className="flex  md:flex-wrap gap-2  md:gap-4 w-full skills list md:text-xl">
            {project.stack.map((project) => (
              <li
                key={project}
                className="stack rounded-3xl bg-slate-200 h-10 flex justify-center items-center px-2"
              >
                {project}
              </li>
            ))}
          </ul>
        </div>
        <h1 className="capitalize lg:text-xl font-semibold py-2">
          Description
        </h1>
        <p>{project.description}</p> <br />
        <p className="pt-4 w-full">
          Visit{" "}
          <a
            className=" text-blue-500 w-fit"
            href={project.url}
            target="_blank"
          >
            {project.title}{" "}
            <GoLinkExternal className={" inline"} size={"1em"} />
          </a>{" "}
        </p>
        <div className="lg:absolute flex w-full gap-2 justify-center lg:justify-end lg:pr-8 py-4 bottom-0 left-0">
          <Link to={`/projects/` + prev} className=" p-4 rounded-full gotoprev">
            {" "}
            <FaIcons.FaArrowLeft size={`1.5em`} />
          </Link>
          <Link
            to={`/projects/` + next}
            className={[` p-4 rounded-full gotonext bg-${colors[0]}`]}
          >
            <FaIcons.FaArrowRight size={`1.5em`} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetail;
